"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    return { disqusId: compData.disqusId };
});
//# sourceMappingURL=DisqusComments.js.map